export interface VoiceEventDTO {
  Status: string;
  MasterId: string;
  ContactId: string;
  CallType?: string;
  Ani?: string;
  Dnis?: string;
  AttachData: any;
  isInboundCall: boolean;
  CallStatus: VoiceCallEventType;
  DisconectCode: string;
  InteractionId: string;
}

export enum VoiceCallDirection {
  Inbound,
  Outbound,
}

export enum VoiceCallEventType {
  Answered,
  Released,
}
